<div class="input-grid-gaps grid-1col">
    <app-select-input
        id="status"
        [form]="form"
        label="person.dashboard.riskStatus.fields.status"
        [staticOptions]="folderRiskStatusEnumOptions"
        [valueKey]="'value'"
        [showClear]="false">
    </app-select-input>

    <app-select-input
        id="riskType"
        [form]="form"
        label="person.dashboard.riskStatus.fields.riskType"
        [staticOptions]="riskTypeOptions"
        [labelKey]="'name'"
        [valueKey]="'name'"
        [showClear]="false">
    </app-select-input>
    <app-date-input [form]="form" id="dateFrom"></app-date-input>
    <app-text-input [form]="form" id="note"></app-text-input>
</div>
